

import React from 'react';
import styled from 'styled-components';
import Slider from 'react-slick';
import { motion } from 'framer-motion';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const MeasurableOutcomes = () => {
    const outcomes = [
        {
            h: "Faster Hiring Cycles",
            sh: "Up To 45% Faster Turnaround",
            desc: "Accelerate workforce expansion through optimized sourcing pipelines and structured recruitment workflows.",
            gradient: "linear-gradient(-45deg, #2563eb 0%, #ffffff 100%)"
        },
        {
            h: "Improved Hiring Quality",
            sh: "Pre-Screened Talent Networks",
            desc: "Connect with technically evaluated and role-aligned candidates across IT, leadership, and specialized categories.",
            gradient: "linear-gradient(-45deg, #3b82f6 0%, #eff6ff 100%)"
        },
        {
            h: "Workforce Scalability",
            sh: "High-Volume Hiring Support",
            desc: "Scale workforce operations confidently during rapid expansion, project growth, or seasonal hiring demand.",
            gradient: "linear-gradient(-45deg, #0284c7 0%, #ffffff 100%)"
        },
        {
            h: "Payroll & Compliance",
            sh: "Reduced Compliance Risks",
            desc: "Ensure smooth payroll processing, statutory compliance management, and PF & ESI handling.",
            gradient: "linear-gradient(-45deg, #1d4ed8 0%, #f0f9ff 100%)"
        },
        {
            h: "Reduced HR Burden",
            sh: "Streamlined Administration",
            desc: "Free internal HR teams from repetitive operational tasks through outsourced workforce management support.",
            gradient: "linear-gradient(-45deg, #60a5fa 0%, #ffffff 100%)"
        },
        {
            h: "Workforce Efficiency",
            sh: "Strategic Resource Allocation",
            desc: "Align recruitment strategies with long-term organizational goals for improved productivity and stability.",
            gradient: "linear-gradient(-45deg, #00d2ff 0%, #ffffff 100%)"
        }
    ];

    const settings = {
        dots: true,
        infinite: true,
        speed: 1000,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        pauseOnHover: true,
        responsive: [
            { breakpoint: 1100, settings: { slidesToShow: 2 } },
            { breakpoint: 768, settings: { slidesToShow: 1 } }
        ]
    };

    return (
        <SectionWrapper>
            <div className="container mx-auto px-6 py-3">
                <div className="text-center ">
                    <motion.p 
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        className="text-white font-mono text-md font-medium mb-4 uppercase"
                    >
                        Success Metrics
                    </motion.p>
                    <motion.h2 
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        className="text-white text-3xl md:text-5xl font-bold syne leading-tight"
                    >
                        HR Solutions Focused On <br /> 
                        <span className="text-[#01014C]">
                            Measurable Business Outcomes
                        </span>
                    </motion.h2>
                    <motion.p 
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        className="text-white/80 text-sm md:text-lg max-w-2xl mx-auto mt-4 leading-relaxed font-medium"
                    >
                        Every strategic decision directly impacts efficiency, scaling capability, and overall profitability. Our consulting solutions deliver key outcomes that align with your growth objectives.
                    </motion.p>
                </div>

                <Slider {...settings} className="outcome-slider">
                    {outcomes.map((item, index) => (
                        <CardContainer key={index} gradient={item.gradient}>
                            <div className="main-wrapper">
                                {/* The Glow Layer (Rotates) */}
                                <div className="rotating-bg-layer" />
                                
                                {/* The Content Card (Stays Still) */}
                                <div className="static-content-card">
                                    <p className="heading">{item.h}</p>
                                    <div className="badge-wrap">
                                        <p className="subheading">{item.sh}</p>
                                    </div>
                                    <p className="description">{item.desc}</p>
                                </div>
                            </div>
                        </CardContainer>
                    ))}
                </Slider>
            </div>
        </SectionWrapper>
    );
};


const SectionWrapper = styled.section`
    background-color:#2563EB ; /* Your requested Blue Background */
    padding: 10px 0;
    overflow: hidden;

    .outcome-slider {
        padding: 60px 0;
    }
    
    /* Slick dots styling */
    .slick-dots li button:before { color: rgba(255,255,255,0.2); }
    .slick-dots li.slick-active button:before { color: #22d3ee; }
    
    .slick-list {
        overflow: visible;
    }
`;

const CardContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 40px 0;

  .main-wrapper {
    position: relative;
    width: 300px;
    height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* ROTATING GLOW LAYER */
  .rotating-bg-layer {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 1;
    pointer-events: none;
  }

 .rotating-bg-layer::before {
    content: '';
    position: absolute;
    
    /* CHANGE THESE VALUES */
    width: 306px;   /* Was 320px -> Now only 6px wider than the 300px card */
    height: 406px;  /* Was 420px -> Now only 6px taller than the 400px card */
    left: -3px;     /* Was -10px -> Moves it closer to the edge */
    top: -3px;      /* Was -10px -> Moves it closer to the edge */
    
    border-radius: 20px;
    background: ${props => props.gradient};
    transition: all 0.7s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    z-index: -1;
  }
  .rotating-bg-layer::after {
    content: "";
    position: absolute;
    inset: 0;
    background: ${props => props.gradient};
    transform: scale(0.95);
    filter: blur(25px);
    opacity: 0.3;
    transition: all 0.6s ease;
    z-index: -2;
  }

  /* Hover rotation for background only */
  .main-wrapper:hover .rotating-bg-layer::before {
    transform: rotate(-90deg) scaleX(1.3) scaleY(0.85);
  }

  .main-wrapper:hover .rotating-bg-layer::after {
    filter: blur(40px);
    opacity: 0.7;
  }

  /* STATIC CONTENT CARD (Midnight Blue Glass Look) */
  .static-content-card {
    position: relative;
    width: 100%;
    height: 100%;
    /* Deeper navy for the card itself */
    background-color: #000033; 
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding: 35px;
    gap: 15px;
    border-radius: 16px;
    cursor: pointer;
    z-index: 10;
    border: 1px solid rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(10px);
  }

  .heading {
    font-size: 22px;
    font-weight: 600;
    color: white;
    line-height: 1.2;
    font-family: 'Syne', sans-serif;
  }

  .badge-wrap {
      background: rgba(255,255,255,0.05);
      border: 1px solid rgba(255,255,255,0.1);
      padding: 6px 12px;
      border-radius: 8px;
      width: fit-content;
  }

  .subheading {
    font-size: 12px;
    font-weight: 700;
    color: #22d3ee; /* Neon Cyan for the outcome text */
    text-transform: uppercase;
    letter-spacing: 1px;
  }

  .description {
    font-size: 14px;
    color: rgba(255,255,255,0.6);
    line-height: 1.6;
  }
`;

export default MeasurableOutcomes;